import { __DetectCountry } from './types';

// Build signals for each supported country. Case-insensitive, word-boundary aware where possible
const US_SIGNALS: __DetectCountry.__CountrySignals = {
  keywords: [
    /\busa\b/i,
    /\bu\.s\.a\.?\b/i,
    /\bu\.s\.?\b/i,
    /\bunited states(?: of america)?\b/i,
  ],
  cities: [
    /\bnew york\b/i,
    /\blos angeles\b/i,
    /\bchicago\b/i,
    /\bhouston\b/i,
    /\bmiami\b/i,
    /\bdallas\b/i,
    /\bsan francisco\b/i,
    /\bseattle\b/i,
    /\bboston\b/i,
    /\batlanta\b/i,
  ],
  regionsLong: [
    /\b(alabama|alaska|arizona|arkansas|california|colorado|connecticut|delaware|florida|georgia|hawaii|idaho|illinois|indiana|iowa|kansas|kentucky|louisiana|maine|maryland|massachusetts|michigan|minnesota|mississippi|missouri|montana|nebraska|nevada|new hampshire|new jersey|new mexico|new york|north carolina|north dakota|ohio|oklahoma|oregon|pennsylvania|rhode island|south carolina|south dakota|tennessee|texas|utah|vermont|virginia|washington|west virginia|wisconsin|wyoming)\b/i,
  ],
  regionsShort: [
    /\b(al|ak|az|ar|ca|co|ct|de|fl|ga|hi|id|il|in|ia|ks|ky|la|me|md|ma|mi|mn|ms|mo|mt|ne|nv|nh|nj|nm|ny|nc|nd|oh|ok|or|pa|ri|sc|sd|tn|tx|ut|vt|va|wa|wv|wi|wy)\b/i,
  ],
  postalCode: /\b\d{5}(?:-\d{4})?\b/,
};

const UK_SIGNALS: __DetectCountry.__CountrySignals = {
  keywords: [
    /\buk\b/i,
    /\bunited kingdom\b/i,
    /\bgreat britain\b/i,
    /\bengland\b/i,
    /\bscotland\b/i,
    /\bwales\b/i,
    /\bnorthern ireland\b/i,
    /\bgb\b/i,
  ],
  cities: [
    /\blondon\b/i,
    /\bmanchester\b/i,
    /\bedinburgh\b/i,
    /\bglasgow\b/i,
    /\bbirmingham\b/i,
    /\bleeds\b/i,
    /\bbristol\b/i,
    /\bliverpool\b/i,
    /\bcardiff\b/i,
    /\bbelfast\b/i,
  ],
  regionsLong: [
    /\b(yorkshire|lancashire|cornwall|kent|surrey|sussex|cumbria|norfolk|suffolk|derbyshire|nottinghamshire|oxfordshire|cambridgeshire|essex|hampshire|devon)\b/i,
  ],
  regionsShort: [],
  // Simplified UK postcode regex (covers common formats e.g., SW1A 1AA)
  postalCode: /\b[A-Z]{1,2}\d{1,2}[A-Z]?\s?\d[A-Z]{2}\b/i,
};

export const SIGNALS_BY_COUNTRY: Record<
  __DetectCountry.__SupportedCountry,
  __DetectCountry.__CountrySignals
> = {
  US: US_SIGNALS,
  UK: UK_SIGNALS,
};
